var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-render",style:({zoom: _vm.zoom})},[_c('div',{staticClass:"full-wrap"},_vm._l((_vm.data),function(item){return _c('ComponentRender',{key:item.id,attrs:{"component":item,"is-edit":_vm.isEdit,"is-choose":_vm.isChoose,"current-id":_vm.currentId}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }